// translation helper: looks up key from window.returnTranslations and interpolates {{ var }} placeholders
window.rt = (key, vars) => {
    const str = (window.returnTranslations || {})[key] || key;
    if (!vars) return str;
    return str.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => vars[k] != null ? vars[k] : '');
};

// shared utilities for customer returns (used by return-request-modal.js and account-returns.js)
window.ReturnsUtils = window.ReturnsUtils || {
    async getToken() {
        return window.customerAuth?.getAccessToken?.();
    },

    async apiCall(url, options = {}, retry = true) {
        const token = options.token || await this.getToken();

        const response = await fetch(url, {
            ...options,
            headers: {
                ...(options.headers || {}),
                'Authorization': `Bearer ${token}`
            }
        });

        if (response.status === 403 && retry) {
            const newToken = await window.customerAuth?.refreshAccessToken?.();
            if (newToken) {
                return this.apiCall(url, { ...options, token: newToken }, false);
            }
        }

        return response;
    },

    getFileContentType(file) {
        if (file.type) return file.type;
        const ext = (file.name.split('.').pop() || '').toLowerCase();
        const fallback = {
            jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png',
            gif: 'image/gif', webp: 'image/webp', heic: 'image/heic', heif: 'image/heif',
            mp4: 'video/mp4', mov: 'video/quicktime', webm: 'video/webm',
            m4v: 'video/x-m4v', '3gp': 'video/3gpp'
        };
        return fallback[ext] || 'application/octet-stream';
    },

    uploadFileToS3(presignedUrl, file) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', presignedUrl, true);
            xhr.setRequestHeader('Content-Type', this.getFileContentType(file));

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve();
                } else {
                    reject(new Error('S3 upload failed: ' + xhr.status));
                }
            };

            xhr.onerror = () => reject(new Error('S3 upload network error'));
            xhr.send(file);
        });
    }
};
